import { PartnerCTA } from "@/components/sections/PartnerCTA"
import { PartnersGrid } from "@/components/sections/PartnersGrid"
import { PartnersHero } from "@/components/sections/PartnersHero"
import { useSEO } from "@/hooks/useSEO"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/partners")({
  component: PartnersPage,
})

function PartnersPage() {
  useSEO({
    title: "Partners",
    description:
      "We collaborate with industry-leading organisations across banking, telecoms, payments, technology, and more — delivering integrated solutions that power real outcomes.",
    canonical: "https://orchestrate.global/partners",
  })

  return (
    <div className="min-h-screen bg-neutral-50">
      <PartnersHero />
      <PartnersGrid />
      <PartnerCTA />
    </div>
  )
}
